import { useGetSubscriptionDetailsQuery } from '@/store/api/miscApi';

export const useGetSubscriptionDetails = (subId: string | undefined) =>
  useGetSubscriptionDetailsQuery(
    { subscriptionId: subId as string },
    { skip: !subId },
  );
